import { render } from "./ctcp_request.vue?vue&type=template&id=c34ff826&ts=true"
import script from "./ctcp_request.vue?vue&type=script&lang=ts"
export * from "./ctcp_request.vue?vue&type=script&lang=ts"

import exportComponent from "/root/thelounge/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__